class VGHHeroSlider {
  constructor(section) {
    this.section = section;

    this.slides = Array.from(
      section.querySelectorAll('[data-vgh-slide]')
    );

    this.dots = Array.from(
      section.querySelectorAll('[data-vgh-dot]')
    );

    this.prevButton = section.querySelector('[data-vgh-prev]');
    this.nextButton = section.querySelector('[data-vgh-next]');

    this.currentIndex = 0;

    this.autoplayEnabled =
      section.dataset.autoplay === 'true';

    this.delay =
      Number(section.dataset.delay) || 6000;

    this.interval = null;

    this.bindEvents();
    this.startAutoplay();
  }

  bindEvents() {
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.index);

        this.showSlide(index);
        this.restartAutoplay();
      });
    });

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.previous();
        this.restartAutoplay();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.next();
        this.restartAutoplay();
      });
    }

    this.section.addEventListener('mouseenter', () => {
      this.stopAutoplay();
    });

    this.section.addEventListener('mouseleave', () => {
      this.startAutoplay();
    });

    this.section.addEventListener('focusin', () => {
      this.stopAutoplay();
    });

    this.section.addEventListener('focusout', (event) => {
      if (!this.section.contains(event.relatedTarget)) {
        this.startAutoplay();
      }
    });

    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const selectedSlide =
          event.target.closest('[data-vgh-slide]');

        if (!selectedSlide) {
          return;
        }

        if (!this.section.contains(selectedSlide)) {
          return;
        }

        const index =
          Number(selectedSlide.dataset.index);

        this.showSlide(index);
        this.stopAutoplay();
      }
    );

    document.addEventListener(
      'shopify:block:deselect',
      () => {
        this.startAutoplay();
      }
    );
  }

  showSlide(index) {
    if (this.slides.length === 0) {
      return;
    }

    const normalizedIndex =
      (index + this.slides.length) %
      this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      const isActive =
        slideIndex === normalizedIndex;

      slide.classList.toggle(
        'is-active',
        isActive
      );

      slide.setAttribute(
        'aria-hidden',
        isActive ? 'false' : 'true'
      );
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive =
        dotIndex === normalizedIndex;

      dot.classList.toggle(
        'is-active',
        isActive
      );

      if (isActive) {
        dot.setAttribute(
          'aria-current',
          'true'
        );
      } else {
        dot.removeAttribute(
          'aria-current'
        );
      }
    });

    this.currentIndex =
      normalizedIndex;
  }

  next() {
    this.showSlide(
      this.currentIndex + 1
    );
  }

  previous() {
    this.showSlide(
      this.currentIndex - 1
    );
  }

  startAutoplay() {
    if (!this.autoplayEnabled) {
      return;
    }

    if (this.slides.length <= 1) {
      return;
    }

    this.stopAutoplay();

    this.interval = window.setInterval(
      () => {
        this.next();
      },
      this.delay
    );
  }

  stopAutoplay() {
    if (!this.interval) {
      return;
    }

    window.clearInterval(
      this.interval
    );

    this.interval = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

function initializeVGHHeroSliders() {
  const sliders =
    document.querySelectorAll(
      '[data-vgh-hero]'
    );

  sliders.forEach((slider) => {
    if (
      slider.dataset.vghInitialized ===
      'true'
    ) {
      return;
    }

    slider.dataset.vghInitialized =
      'true';

    new VGHHeroSlider(slider);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeVGHHeroSliders
  );
} else {
  initializeVGHHeroSliders();
}

document.addEventListener(
  'shopify:section:load',
  initializeVGHHeroSliders
);